// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-Gratuity-__Gratuity___3oD1F","tableWrapper":"app-pages-Reports-Sales-Gratuity-__Gratuity___1zNA7","tableWrapperResponsive":"app-pages-Reports-Sales-Gratuity-__Gratuity___2TIuG"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Sales/Gratuity/Gratuity.css
// module id = 2216
// module chunks = 0